angular.module('env.data.models.documentModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("DocumentModel",
            {
                extend: ['BaseModel', 'CustomFieldAwareModel'],
                url: "documents",
                fields: {
                    fileName: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    fileVersion: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    checkedOut: {
                        type: RepresentationModelFieldTypes.BOOLEAN
                    },
                    checkedOutBy: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    checkedOutById: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    size: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    archiveJobLogEntryId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    }
                }
            }
        );
    })

;
